
import { useRecaptcha } from "@/hooks/useRecaptcha";
import { useEffect } from "react";

interface RecaptchaProviderProps {
  children: React.ReactNode;
}

export function RecaptchaProvider({ children }: RecaptchaProviderProps) {
  const { isLoaded } = useRecaptcha();

  useEffect(() => {
    if (isLoaded) {
      console.log('reCAPTCHA v3 carregado com sucesso');
    }
  }, [isLoaded]);

  return <>{children}</>;
}
